export default "__VITE_ASSET__H6O2Zjpc__"